import { getDiscount, getDiscountRange } from './../../Api/subscriptionApi';
import { ApiCompanyPhoneResult, ApiCompanyPhoneCheck } from './../../Types/CompanyAccount/Api';
import { getCompanyPhone, getAccountStatus } from './../../Api/companyApi';
import { pickUserPhone, addPhoneValid } from 'Api/userApi';
import { apiErrorList } from 'Services/restAdviser';
import { addPhone, getPhoneList, removePhone, checkPhone, refreshPhoneToken } from './../../Api/userPhoneApi';
import { CancelToken } from 'axios'
import { uploadFile } from 'Api/uploadApi'
import { parseCompanyAccountPhotoList, parseCompanyAccount } from 'Parsers/companyAccountParser'
import { formatCompanyAccountAsync } from 'Formatters/companyAccountFormatter'
import {
  uploadLogo as uploadCompanyLogo,
  uploadPhoto as uploadCompanyPhoto,
  deletePhoto as deleteComapanyPhoto,
  getPhotos,
  getCompanyInfo,
  editCompanyInfo,
} from 'Api/companyApi'
import cloneDeep from 'lodash/cloneDeep'

const state = {
  requesting: {
    info: false,
    infoSubmit: false,
    logoUpload: false,
    photoUpload: false,
    photoDelete: false,
    phoneCheck: false,
    phoneValidation: false,
    getDiscount: false,
    getDiscountRange: false,
    getStatus: false

  },

  info: {
    id: null,
    name: '',
    logo: '',
    about: '',
    slug: '',
    serviceDescription: '',
    advantangeList: [],
    endorsementList: [],
    website: '',
    phone: {
      id: 0,
      ddd: '',
      number: '',
      token: '',
      isPhoneValidated: false
    },
    discount360: {
      initialDate: '',
      endDate: '',
      totalQuotation: 0
    },
    discountRange: [],
    is360Partner: false
  },

  typeReceivement: 2,
  photoList: [],
  companyStatus: null,
  daysToBlock: null,
  companyStatusDescription: null,

  cancelToken: {
    gallery: null,
    logo: null,
  }
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },
  set_photo_list(state, photoList) {
    state.photoList = photoList
  },
  set_info(state, info) {
    state.info = info
  },
  set_logo(state, logo) {
    state.info.logo = logo
  },
  set_cancel_token(state, { type, token }) {
    state.cancelToken[type] = token
  },
  set_ddd(state, ddd ) {
    state.info.phone.ddd = ddd

  },
  set_phone_number(state, number ) {
    state.info.phone.number = number
  },

  set_verified_phone(state, verifiedPhone) {
    state.info.phone.isPhoneValidated = verifiedPhone
  },

  set_discount_360(sate, discount) {
    state.info.discount360 = discount
  },

  set_discount_rage(state, discount) {
    state.info.discountRange = discount
  },

  set_type_receivement(state, value) {
    state.typeReceivement = value
  },

  set_company_status(state, status) {
    state.companyStatus = status
  },

  set_company_status_description(state, statusDescriptiob) {
    state.companyStatusDescription = statusDescriptiob
  },

  set_days_to_block(state, days) {
    state.daysToBlock = days
  }
}

const actions = {
  
  async getInfo({ commit }) {
    commit('request_start', 'info')

    try {
      const infoData = await getCompanyInfo()
      const phoneData = await pickUserPhone()

      const data  =  { ...infoData.data, ...{ phone: phoneData.data }}

      const info = parseCompanyAccount(data)

      commit('set_info', info)

      commit('request_success', 'info')

      return data
    } catch (err) {
      commit('request_failure', 'info')

      throw err
    }
  },

  async submitInfo({ commit, dispatch }, info) {
    commit('request_start', 'infoSubmit')

    try {
      const data = await formatCompanyAccountAsync(info)
      const result = await editCompanyInfo(data)

      await dispatch('account/refreshAccountInfo', null, { root: true })

      commit('request_success', 'infoSubmit')

      return result
    } catch (err) {
      commit('request_failure', 'infoSubmit')

      throw err
    }
  },

  async uploadLogo({ commit, dispatch }, { file, logger }) {
    commit('request_start', 'logoUpload')

    try {
      // @ts-ignore
      const logoToken = CancelToken.source()

      commit('set_cancel_token', {
        type: 'logo',
        token: logoToken
      })

      const { data }  = await uploadFile(file, logger, logoToken.token)
      const result = await uploadCompanyLogo(data.path)

      await dispatch('account/refreshAccountInfo', null, { root: true })

      commit('set_logo', result.data.imageSmallUrl)

      commit('request_success', 'logoUpload')

      return result
    } catch (err) {
      commit('request_failure', 'logoUpload')

      throw err
    }
  },

  async uploadPhoto({ commit }, { file, description, logger }) {
    commit('request_start', 'photoUpload')

    try {
      // @ts-ignore
      const logoToken = CancelToken.source()

      commit('set_cancel_token', {
        type: 'logo',
        token: logoToken
      })

      const { data }  = await uploadFile(file, logger, logoToken.token)
      const result = await uploadCompanyPhoto(data.path, description)

      commit('request_success', 'photoUpload')

      return result
    } catch (err) {
      commit('request_failure', 'photoUpload')

      throw err
    }
  },

  async deletePhoto({ commit }, id) {
    commit('request_start', 'photoDelete')

    try {
      const result = await deleteComapanyPhoto(id)
      commit('request_success', 'photoDelete')

      return result
    } catch (err) {
      commit('request_failure', 'photoDelete')
      throw err
    }
  },

  async getPhotoList({ commit }) {
    commit('request_start', 'photoList')
    try {
      const { data } = await getPhotos()

      const photoList = parseCompanyAccountPhotoList(data)
      commit('set_photo_list', photoList)

      commit('request_success', 'photoList')

      return data
    } catch (err) {
      commit('request_failure', 'photoList')

      throw err
    }
  },

  updateInfo({ commit, state }, info) {
    commit('set_info', Object.assign(
      cloneDeep(state.info),
      info
    ))
  },

  cancelUpload({ commit, state }, type) {
    const { cancelToken } = state

    if (cancelToken[type] !== null) {
      const { cancel } = cancelToken[type]

      cancel()
    }

    commit('set_cancel_token', {
      type: type,
      token: null
    })
  },

  updateInfoDDD({ commit }, ddd){
    commit('set_ddd', ddd)
  },

  updateInfoPhoneNumber({ commit }, phoneNumber){
    commit('set_phone_number', phoneNumber)
  },

  async createPhoneForVerification({ state, commit }) {
    const { ddd, number } = state.info.phone
    const  typeReceivement  = state.typeReceivement ||  2

    var formatedNumber = `${number.replace(/[^0-9]/g, '')}`

    const { data } = await addPhone(ddd, formatedNumber, typeReceivement)

    return data.token
  },

  async deletePhone({ commit }, phone: ApiCompanyPhoneResult) {
    const { data } = await removePhone(phone.id)

    return data
  },

  async requestPhoneVerification({ state, commit, dispatch }) {
    commit('request_start', 'phoneCheck')

    try {
      const { ddd, number } = state.info.phone
      const { data } = await getPhoneList()

      const phone = data.find(item =>
        item.number === number && item.localCodeArea === ddd
      )

      if (phone) {
        await dispatch('deletePhone', phone)
      }

      const token = await dispatch('createPhoneForVerification')

      commit('request_success', 'phoneCheck')

      return token
    } catch (err) {

      commit('request_failure', 'phoneCheck')

      throw err
    }
  },
  async validatePhone({ commit, dispatch }, payload: ApiCompanyPhoneCheck) {
    commit('request_start', 'phoneValidation')

    try {
      const { data } = await checkPhone(payload)

      commit('set_verified_phone', true)

      dispatch('addPhoneValid')

      commit('request_success', 'phoneValidation')

      return data
    } catch (err) {

      commit('request_failure', 'phoneValidation')

      throw err
    }
  },

  async refreshPhoneToken({ state }) {
    const { ddd, number } = state.info.phone
    const { typeReceivementValue } = state.typeReceivement
    var formatedNumber = `${number.replace(/[^0-9]/g, '')}`
    try {
      const { data } = await refreshPhoneToken(ddd, formatedNumber, typeReceivementValue)

      return data.token
    } catch (err) {
      throw err
    }
  },

  async addPhoneValid({commit, state, dispatch}) {
    commit('request_start', 'addPhoneValid')
    try {
      const payload = {
        id: state.info.phone.id,
        ddd: state.info.phone.ddd,
        number: state.info.phone.number.replace('-', ''),
        ddi: '55',
        isVerified: true
      }
      const {data} = await addPhoneValid(payload)

      dispatch('getInfo')

      commit('request_success', 'addPhoneValid')

      return data
    } catch (error) {
      commit('request_failure', 'addPhoneValid')
    }
  },

  async getDiscount({ commit }) {
    commit('request_start', 'getDiscount')
    try {
      const { data } = await getDiscount()
      commit('set_discount_360', data)

      commit('request_success', 'getDiscount')

      return data
    } catch (error) {
      commit('request_failure', 'getDiscount')

    }
  },

  async getDiscountRange({ commit }) {
    commit('request_start', 'getDiscountRange')
    try {
      const { data } = await getDiscountRange()
      commit('set_discount_rage', data)

      commit('request_success', 'getDiscountRange')

      return data
    } catch (error) {
      commit('request_failure', 'getDiscountRange')

    }
  },

  async getStatus({ commit }) {
    commit('request_start', 'getStatus')

    try {
      commit('request_success', 'getStatus')
      const { data } = await getAccountStatus()

      commit('set_company_status', data.status)
      commit('set_company_status_description', data.statusDescription)
      commit('set_days_to_block', data.daysToBlock ?? null)

      return data
    } catch (error) {
      commit('request_failure', 'getStatus')

    }
  },

  updateTypeReceivement({ commit }, value) {
    commit('set_type_receivement', value)
  },

}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}